module.exports = __webpack_public_path__ + "static/media/SP_top_ranking_recipe.b15bff81.jpg";